import * as React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import * as DTOS from "../../../../FeralScan.dtos";
import { IAppState } from '../../../../app';
import { IBasePageProps } from '../../configuration/IConfiguration';
import * as UserActionCreators from "../../../../actions/user.actions";
import { LocalForm, Control } from 'react-redux-form';
import * as classNames from "classnames";
import AdminContactEmailLink from '../../../Content/AdminContactEmailLink';

type PageActivateAccountResendProps = {
    theme?: string,
}

type PageActivateAccountResendActions = {
}


type PageActivateAccountResendRouteParams = {
}

type PageActivateAccountResendQueryParams = {
    activateAccountToken: string;
}

type PageActivateAccountResendPropsMapped = { 
}

type PageActivateAccountResendActionsMapped = {
    activateAccount: typeof UserActionCreators.activateAccount;
    sendActivateAccount: typeof UserActionCreators.sendActivateAccount;
}

type PageActivateAccountResendAllPropsInherited = PageActivateAccountResendProps & PageActivateAccountResendActions;
type PageActivateAccountResendAllPropsMapped = PageActivateAccountResendPropsMapped & PageActivateAccountResendActionsMapped;

type PageActivateAccountResendAllProps = IBasePageProps<PageActivateAccountResendRouteParams, PageActivateAccountResendQueryParams> & Partial<PageActivateAccountResendAllPropsMapped> & PageActivateAccountResendAllPropsInherited;

interface IPageActivateAccountResendState {
    requestMade: boolean;
    requestUsername: string;
}

class PageActivateAccountResend extends React.Component<PageActivateAccountResendAllProps, IPageActivateAccountResendState> {
    formDispatch;
    constructor(props, context) {
        super(props, context);

        this.state = { requestMade: false, requestUsername: undefined }

        this.onRequestNewActivationLink = this.onRequestNewActivationLink.bind(this);
    }

    onRequestNewActivationLink(username: string) {
        this.props.sendActivateAccount(username);
        this.setState({ requestMade: true, requestUsername: username });
    }

    render() {
        const requestResendForm = <><p>If you didn't receive your account activation email you may request another using the form below. Please be patient, if you only just registered it can take a few minutes to arrive in your email inbox. Your email may have also been sent to Spam or Trash - so check there first.</p>
            <p>To request another email please enter the <strong>email address</strong> you used during registration. You will be emailed a link to activate your account.</p>
            <LocalForm
                model="activateAccount"
                className={classNames(this.props.theme, "form activate-form")}
                onSubmit={activateAccount => this.onRequestNewActivationLink(activateAccount.username)}
                getDispatch={(dispatch) => this.formDispatch = dispatch}
                validateOn="submit">
                <div className="form-fields">
                    <label className="lead my-0">Email Address</label>
                    <Control.text
                        model=".username"
                        id="activateAccount.username"
                        className="form-control form-control-sm mb-2"
                        maxLength={100}
                        required={true}
                    />
                    <button className={classNames(this.props.theme, "btn btn-primary btn-lg mt-2 align-self-end")}>SEND</button>
                </div>
            </LocalForm></>;

        return (
            <div className="mx-lg-3 mt-3 col-md-6 col-12">
                <h3>Request Account Activation</h3>
                {
                    this.state.requestMade ? <>
                        <p>A new account activation email has been sent to the email address you provided. Please be patient, it can take a few minutes to arrive in your email inbox. Your email may have also been sent to Spam or Trash so check for it there.</p>
                        
                        <p>If it has been more than 4 hours and your email has not arrived, you may contact us here: <AdminContactEmailLink subject={`Account%20Activation:%20${this.state.requestUsername ? this.state.requestUsername : 'ERROR:UnknownEmailAddress'}`} />. Please do not change the email subject as this will prevent us from helping you as soon as possible.</p>
                    </>
                    : requestResendForm
                }
            </div>


        );
    }
}

const mapStateToProps = (state: IAppState, ownProps: PageActivateAccountResendAllProps): PageActivateAccountResendPropsMapped => {

    return {
    }
}

const mapDispatchToProps = (dispatch) => {
    return bindActionCreators<PageActivateAccountResendActionsMapped>({
        activateAccount: UserActionCreators.activateAccount,
        sendActivateAccount: UserActionCreators.sendActivateAccount,
    }, dispatch)
}

export default connect(mapStateToProps, mapDispatchToProps)(PageActivateAccountResend);